import * as activeFeedActions from './actions';
import * as userActions from '../user/actions';
import * as generalActions from '../GENERAL/actions';
import { CLEAN_PERSISTED_STORAGE } from '~redux_related/GENERAL/actions';

export const newsFeeds = {
    ALL_NEWS: 'NEWS_ALL_NEWS',
    FAVORITE_NEWS: 'NEWS_FAVORITE_NEWS',
};

export const lawsFeeds = {
    ALL_PUBLICATIONS: 'LAWS_ALL_PUBLICATIONS',
    MY_FAVORITES: 'LAWS_MY_FAVORITES',
    MY_ACTIONS: 'LAWS_MY_ACTIONS',
    WAITING_FOR_ANSWER: 'LAWS_WAITING_FOR_ANSWER',
};

export const priorityFilters = {
    allPublications: {
        name: 'Все публикации',
        id: 'all',
    },
    liked: {
        name: 'Мое избранное',
        id: 'liked',
    },
    myActions: {
        name: 'Мои действия',
        id: 'my_actions',
    },
    waiting: {
        name: 'Ожидает ответа',
        id: 'waiting',
    },
};

const initialState = {
    activeNewsFeed: newsFeeds.ALL_NEWS,
    activeLawsFeed: lawsFeeds.ALL_PUBLICATIONS,
};

export const activeFeedReducer = (state = initialState, action) => {
    switch (action.type) {
        // NEWS
        case activeFeedActions.SET_ACTIVE_NEWS_FEED_ALL_NEWS:
            return {
                ...state,
                activeNewsFeed: newsFeeds.ALL_NEWS,
            };

        case activeFeedActions.SET_ACTIVE_NEWS_FEED_FAV_NEWS:
            return {
                ...state,
                activeNewsFeed: newsFeeds.FAVORITE_NEWS,
            };

        // LAWS
        case activeFeedActions.SET_ACTIVE_LAWS_FEED_ALL_PUB:
            localStorage.setItem('activeFeed', 'all_pub');
            return {
                ...state,
                activeLawsFeed: lawsFeeds.ALL_PUBLICATIONS,
            };

        case activeFeedActions.SET_ACTIVE_LAWS_FEED_MY_FAV:
            localStorage.setItem('activeFeed', 'my_fav');
            return {
                ...state,
                activeLawsFeed: lawsFeeds.MY_FAVORITES,
            };

        case activeFeedActions.SET_ACTIVE_LAWS_FEED_MY_ACTIONS:
            localStorage.setItem('activeFeed', 'my_actions');
            return {
                ...state,
                activeLawsFeed: lawsFeeds.MY_ACTIONS,
            };

        case activeFeedActions.SET_ACTIVE_LAWS_FEED_WAITING_ANSWER:
            localStorage.setItem('activeFeed', 'waiting_answer');
            return {
                ...state,
                activeLawsFeed: lawsFeeds.WAITING_FOR_ANSWER,
            };

        case generalActions.APPLY_COVID_FILTERS:
            return {
                ...state,
                activeLawsFeed: lawsFeeds.ALL_PUBLICATIONS,
            };

        case generalActions.APPLY_SEMANTIC_FILTERS:
            return {
                ...state,
                activeLawsFeed: lawsFeeds.ALL_PUBLICATIONS,
            };

        case userActions.LOGIN:
            // console.log('+++LOGIN USER 1+++');
            const ecosystemFunctions = action.user && action.user.ecosystem && action.user.ecosystem.functions;
            const isAllPubHidden = ecosystemFunctions instanceof Object && ecosystemFunctions.hide_all_publications_tab;
            const isMyFavoritesHidden =
                ecosystemFunctions instanceof Object && ecosystemFunctions.hide_my_favourites_tab;
            const isMyActionsHidden = ecosystemFunctions instanceof Object && ecosystemFunctions.hide_my_actions_tab;
            const isWaitingHidden = ecosystemFunctions instanceof Object && ecosystemFunctions.hide_waiting_tab;
            if (!isAllPubHidden) {
                return {
                    ...state,
                    activeLawsFeed: lawsFeeds.ALL_PUBLICATIONS,
                };
            }
            if (!isMyFavoritesHidden) {
                return {
                    ...state,
                    activeLawsFeed: lawsFeeds.MY_FAVORITES,
                };
            }
            if (!isMyActionsHidden) {
                return {
                    ...state,
                    activeLawsFeed: lawsFeeds.MY_ACTIONS,
                };
            }
            if (!isWaitingHidden) {
                return {
                    ...state,
                    activeLawsFeed: lawsFeeds.WAITING_FOR_ANSWER,
                };
            }
            return {
                ...state,
                activeLawsFeed: lawsFeeds.ALL_PUBLICATIONS,
            };

        case CLEAN_PERSISTED_STORAGE:
            console.log('+++CLEAN PERSISTED STORAGE 1+++');
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/redux_related/activeFeed/reducer.js